module.exports = __webpack_public_path__ + "static/media/dolce&gabbana-k-by-dolce&gabbana-big.d8eb2021.png";